import React from 'react'

/* container */
import ImpressumContainer from '../../app-module-impressum-container/default'
/* container */

import Contents from '../contents/contents'

import ScrollToTop from '../../../scrollToTop'

const index = (props) => {
  return (
    <ImpressumContainer {...props}>
      <ScrollToTop {...props} />
      <Contents {...props} />
    </ImpressumContainer>
  )
}

export default index
